import { render, staticRenderFns } from "./GoBackButton.vue?vue&type=template&id=80600daa&lang=pug"
import script from "./GoBackButton.vue?vue&type=script&lang=ts"
export * from "./GoBackButton.vue?vue&type=script&lang=ts"
import style0 from "./GoBackButton.vue?vue&type=style&index=0&id=80600daa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports